/**
 * module 级联选择模板
 * createdBy he.zhikai
 * createdIn 2017-03-08
 */
'use strict';
angular.module('util.trsCascader', []).
directive('trsCascader', ['$timeout', function($timeout) {
    return {
        scope: {
            callback: "&", //回调函数
            options: "=", //下拉框数据
            selectedOption: "=", //已选中一级数据
            selectedChildrenOption: "=", //已选中二级数据
            namekey: "@", //name值字段
            valuekey: "@", //value值字段
            children: "@", //子栏目的字段
            placeHolder: "@", //未选中数据时显示的内容
        },
        restrict: 'E',
        templateUrl: './components/util/trsCascader/trsCascader_tpl.html',
        link: function(scope, element, attrs, controller) {
            initStatus();

            /**
             * [initStatus description] 初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
                scope.status = {
                    showOptionList: false, //是否显示下拉框
                    mouseOver: false //鼠标是否在数据框内
                };
                scope.data = {
                    selectedTemp: angular.isDefined(scope.selectedChildrenOption[scope.namekey?scope.namekey:'name']) ? scope.selectedOption[scope.namekey?scope.namekey:'name'] + " / " + scope.selectedChildrenOption[scope.namekey?scope.namekey:'name'] : "", //div中展示的数据
                    preOptionTemp: {}, //上次选中的一级数据
                    preChildrenOptions: [], //上次选中一级数据下的二级数据列表
                    isShowPreOption: false, //是否显示上次选中的数据，防止选中一级数据不选二级数据后显示错误的情况
                    childrenOptions: [] //下拉框二级数据列表
                };
                //点击该组件以外的其他元素时隐藏下拉框
                $("*").click(function(event) {
                    if ($(this).closest('.trsCascader').length === 0) {
                        element.find('#trsCascader_options').fadeOut();
                        element.find('#trsCascader_childrenOptions').fadeOut();
                        scope.status.showOptionList = false;
                    } else {
                        event.stopPropagation(); //阻止事件冒泡   
                    }
                });
                //若初始化时已有选中的数据，则根据数据展示相应的二级数据
                if(scope.selectedOption!=="") {
                    angular.forEach(scope.options, function(data, index) {
                        if(data[scope.valuekey?scope.valuekey:'value'] == scope.selectedOption[scope.valuekey?scope.valuekey:'value']) {
                            scope.data.childrenOptions = data[scope.children?scope.children:'children'];
                        }
                    });
                }
            }

            /**
             * [showOptionList description] 显示或隐藏下拉框
             * @return {[type]} [description]
             */
            scope.showOptionList = function() {
                if (scope.status.showOptionList === true) {
                    element.find('#trsCascader_options').fadeOut();
                    element.find('#trsCascader_childrenOptions').fadeOut();
                    scope.status.showOptionList = false;
                } else {
                    if(scope.data.selectedTemp!=='') {
                        if(scope.data.isShowPreOption === true) {
                            //若之前有未完成的选择，则显示上次选中时的数据
                            scope.selectedOption = angular.copy(scope.data.preOptionTemp);
                            scope.data.childrenOptions = angular.copy(scope.data.preChildrenOptions);
                        }
                        element.find('#trsCascader_options').fadeIn();
                        element.find('#trsCascader_childrenOptions').fadeIn();
                        //滚动条自动滚到所选数据的位置
                        angular.forEach(scope.data.childrenOptions, function(data, index) {
                            if(data[scope.valuekey?scope.valuekey:'value']==scope.selectedChildrenOption[scope.valuekey?scope.valuekey:'value']) {
                                $timeout(function() {
                                    element.find('#trsCascader_childrenOptions').scrollTop(index*29);
                                });
                            }
                        });
                    } else {
                        scope.selectedOption = {};
                        element.find('#trsCascader_options').fadeIn();
                    }
                    scope.status.showOptionList = true;
                }
            };

            /**
             * [selectOption description] 选择一级数据
             * @param  {[type]} option [description]
             * @return {[type]}        [description]
             */
            scope.selectOption = function(option) {
                scope.data.isShowPreOption = true; //选择了一级数据未选择二级数据时
                scope.data.childrenOptions = option[scope.children?scope.children:'children'];
                scope.selectedOption[scope.namekey?scope.namekey:'name'] = option[scope.namekey?scope.namekey:'name'];
                scope.selectedOption[scope.valuekey?scope.valuekey:'value'] = option[scope.valuekey?scope.valuekey:'value'];
                element.find('#trsCascader_childrenOptions').fadeIn();
                angular.forEach(scope.data.childrenOptions, function(data, index) {
                    if(data[scope.valuekey?scope.valuekey:'value']==scope.selectedChildrenOption[scope.valuekey?scope.valuekey:'value']) {
                        $timeout(function() {
                            element.find('#trsCascader_childrenOptions').scrollTop(index*29);
                        });
                    }
                });
            };

            /**
             * [selectChildrenOption description] 选择二级数据
             * @param  {[type]} childrenOption [description]
             * @return {[type]}                [description]
             */
            scope.selectChildrenOption = function(childrenOption) {
                scope.data.isShowPreOption = false;
                scope.selectedChildrenOption[scope.namekey?scope.namekey:'name'] = childrenOption[scope.namekey?scope.namekey:'name'];
                scope.selectedChildrenOption[scope.valuekey?scope.valuekey:'value'] = childrenOption[scope.valuekey?scope.valuekey:'value'];
                scope.data.selectedTemp = scope.selectedOption[scope.namekey?scope.namekey:'name'] + " / " + scope.selectedChildrenOption[scope.namekey?scope.namekey:'name'];
                //临时保存已经选中的一二级数据
                scope.data.preOptionTemp = angular.copy(scope.selectedOption);
                scope.data.preChildrenOptions = angular.copy(scope.data.childrenOptions);
                element.find('#trsCascader_options').fadeOut();
                element.find('#trsCascader_childrenOptions').fadeOut();
                scope.status.showOptionList = false;
                $timeout(function() {
                    scope.callback();
                });
            };

            /**
             * [deleteOption description] 清除已选的数据
             * @param  {[type]} ev [description]
             * @return {[type]}    [description]
             */
            scope.deleteOption = function(ev) {
                //阻止事件冒泡，点击删除时不显示下拉框
                ev.preventDefault();
                ev.stopPropagation();
                //清空所有数据和状态
                scope.data.selectedTemp = "";
                scope.data.preOptionTemp = {};
                scope.data.preChildrenOptions = [];
                scope.data.isShowPreOption = false;
                scope.data.childrenOptions = [];
                scope.selectedOption = {};
                scope.selectedChildrenOption = {};
                element.find('#trsCascader_options').fadeOut();
                element.find('#trsCascader_childrenOptions').fadeOut();
                scope.status.showOptionList = false;
                $timeout(function() {
                    scope.callback();
                });
            };
        }
    };
}]);
